import emobilityImg from '@/assets/icons/images/teaser_emobility.jpg';
import energieberatungImg from '@/assets/icons/images/teaser_energieberatung.jpg';
import solarImg from '@/assets/icons/images/teaser_solar.jpg';

const teaserCardsData = [
    {
        id: "teaser-energie",
        imageSrc: energieberatungImg,
        imageAlt: 'Ein Mann und eine Frau sitzen mit einer Energieberaterin an einem Tisch, besprechen Unterlagen und schauen auf ein Tablet.',
        headline: 'Energieberatung für Häuser älter als 10 Jahre',
        text: 'Das Energieberatungspaket unserer Partner für die energetische Modernisierung Ihres Hauses',
        buttonText: 'Energieberatung',
        buttonLink: 'https://www.vattenfall.de/waerme/energieberatung'
    },
    {
        id: "teaser-solar",
        imageSrc: solarImg,
        imageAlt: 'Ein Mann steht neben einem großen Solarmodul, lächelt und hält ein Tablet in der Hand.',
        headline: 'Solarstrom einfach selbst erzeugen',
        text: 'Bis zu 80% des Strombedarfs ihres Hauses decken und unabhängiger von steigenden Strompreisen werden.',
        buttonText: 'PV-Komplettanlage',
        buttonLink: 'https://www.vattenfall.de/solar/pv-komplettanlage'
    },
    {
        id: "teaser-wallbox",
        imageSrc: emobilityImg,
        imageAlt: 'Ein Elektroauto wird an einer Ladestation im Freien aufgeladen, das Ladekabel ist verbunden.',
        headline: 'Elektromobilität wird Teil des Alltags',
        text: 'Lösungen zum Ausbau der Ladeinfrastruktur für Ihr Zuhause mit Wunsch -Wallbox.',
        buttonText: 'Wallboxen',
        buttonLink: 'https://www.vattenfall.de/emobility/wallboxen'
    }
];

export default teaserCardsData;